module.exports = __webpack_public_path__ + "img/template.9d000500.png";